// First-touch marketing attribution. Captures UTM params + referral code from the
// arrival URL and stores them locally so we can attach them to the eventual signup.
// No per-visit tracking, no network calls, privacy-first, cost-free.
import { safeLocal } from "./safeStorage";

const KEY = "ss_attribution";

export const captureAttribution = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const utm = {
      source: p.get("utm_source") || "",
      medium: p.get("utm_medium") || "",
      campaign: p.get("utm_campaign") || "",
    };
    const ref = p.get("ref") || p.get("invite") || p.get("key") || "";
    const hasAny = utm.source || utm.medium || utm.campaign || ref;
    if (!hasAny) return;
    // First-touch: don't overwrite an existing capture.
    if (safeLocal.get(KEY)) return;
    safeLocal.set(KEY, JSON.stringify({ utm, ref, at: new Date().toISOString() }));
  } catch { /* ignore */ }
};

export const getAttribution = () => {
  try {
    const raw = safeLocal.get(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

export const clearAttribution = () => { try { safeLocal.remove(KEY); } catch { /* ignore */ } };
